import ComplaintService from '../services/complaint-service';

export const complaint = {
  namespaced: true,
  state: { record: null, timeline: [], owners: [], businesses: [] },
  actions: {
    async getOwners({ commit }) {
      const owners = await ComplaintService.owners();
      commit('setOwners', owners);
      return owners;
    },
    async get({ commit }, reference) {
      commit('setRecord', null);
      const detail = await ComplaintService.get(reference);
      commit('setRecord', detail.complaint);
      commit('setBusinesses', detail.businesses || []);
      return detail.complaint;
    },
    async update({ commit }, { reference, changes }) {
      const record = await ComplaintService.update(reference, changes);
      commit('setRecord', record);
      return record;
    },
    async getTimeline({ commit }, { reference, scope, workflowId }) {
      const timeline = await ComplaintService.timeline(reference, scope, workflowId);
      commit('setTimeline', timeline);
      return timeline;
    },
    addNote(_context, { reference, note }) {
      return ComplaintService.addNote(reference, note);
    },
  },
  mutations: {
    setRecord(state, record) {
      state.record = record;
    },
    setTimeline(state, timeline) {
      state.timeline = timeline;
    },
    setOwners(state, owners) {
      state.owners = owners;
    },
    setBusinesses(state, businesses) {
      state.businesses = businesses;
    },
  },
};
